import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import FooterSocialMedia from './FooterSocialMedia';

const FooterContainer = styled.footer`
  background-color: #222;
  color: #ddd;
  padding: 60px 0 30px 0;
  font-size: 0.95rem;
`;

const FooterTitle = styled.h5`
  color: #fff;
  font-weight: 600;
  margin-bottom: 20px;
`;

const FooterLink = styled.a`
  display: block;
  color: #ddd;
  margin-bottom: 10px;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

const SocialIcons = styled.div`
  margin-top: 20px;

  a {
    color: #ddd;
    margin-right: 15px;
    font-size: 1.3rem;

    &:hover {
      color: #119687;
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  border-top: 1px solid #444;
  padding-top: 20px;
  font-size: 0.85rem;
  color: #aaa;
`;

const FooterSection = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};

  return (
    <FooterContainer>
      <Container>
        <Row>
          <Col xs={12} md={4} className="mb-4">
            <FooterTitle>{church.church_name || 'Our Church'}</FooterTitle>
            <p>{church.footer_tagline || 'Reaching People. Building Lives. Transforming Communities.'}</p>
            <SocialIcons>
              <a href={church.facebook || '#'} target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href={church.twitter || '#'} target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href={church.instagram || '#'} target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href={church.youtube || '#'} target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </SocialIcons>
          </Col>

          <Col xs={12} md={4} className="mb-4">
            <FooterTitle>Quick Links</FooterTitle>
            <FooterLink href="/">Home</FooterLink>
            <FooterLink href="#about">About</FooterLink>
            <FooterLink href="#ministries">Ministries</FooterLink>
            <FooterLink href="#contact">Contact</FooterLink>
          </Col>

          <Col xs={12} md={4}>
            <FooterTitle>Contact Us</FooterTitle>
            <p>Email: {church.email || 'customercare@roshtech.co.ke'}</p>
            <p>Phone: {church.phone || '+254 717 245 218'}</p>
            <p>Location: {church.location || 'Nairobi, Kenya'}</p>

            <FooterSocialMedia/>
          </Col>
        </Row>

        <Copyright>
          © {new Date().getFullYear()} ROSHTECH All rights reserved.
        </Copyright>
      </Container>
    </FooterContainer>
  );
};

export default FooterSection;
